import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { IconBtn, UiInput, UiSelect } from '@ru-digital-assets/ui-component';

import DetailsContainer from '../../containers/details-container';
import FormFooter from '../../containers/form-footer';
import AppPageMain from '../../modules/app-page/app-page--main';
import PageHeader from '../../modules/page-header';
import { OptionType } from '../../modules/ui/ui-select/ui-select';
import { useAppDispatch } from '../../store';
import { initUcp } from '../../store/actions/operations-sign';
import { RootState } from '../../types';
import { thunkResultHandler } from '../../utils/thunks/thunkResultHandler';

import UcpIcon from './ucp-btn.svg';

const OrderSelectPaymentPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useAppDispatch();

  const [initialTokenName, setTokenName] = useState<string>();
  const [paymentCount, setPaymentCount] = useState<number>();

  const paymentTypes = useSelector(
    (state: RootState) => state.commonInfo.paymentTokens
  );

  const paymentOptionTypes = useMemo(
    () =>
      paymentTypes.map((item) => ({
        value: item.code,
        label: item.name,
      })),
    [paymentTypes]
  );

  const handleSubmit = () => {
    initialTokenName &&
      paymentCount &&
      dispatch(
        initUcp({ id: parseInt(id, 10), initialTokenName, paymentCount })
      ).then((action) => {
        thunkResultHandler(action, () =>
          history.push(`/orders/${id}/realizations/sign`)
        );
      });
  };

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/orders', title: 'Реестр' },
                {
                  link: `/orders/${id}`,
                  title: `Поставка ${id}`,
                },
              ]}
              iconType="order"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <DetailsContainer
              title="Решение о выпуске гибридного токена"
              onClose={() => history.back()}
              infoTitle={{
                description:
                  'Выберите токен в качестве встречного предоставления',
              }}
              leftComponent={
                <>
                  <form className="form-assets">
                    <div className="form-assets__item flex">
                      <div
                        className="assets-tabs__filter--500"
                        style={{ marginRight: '16px' }}
                      >
                        <UiSelect
                          placeholder="Наименование токена"
                          options={paymentOptionTypes}
                          lg
                          onChange={(val) => {
                            setTokenName((val as OptionType)?.value);
                          }}
                        />
                      </div>
                      <UiInput
                        required
                        rightText="шт"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setPaymentCount(
                            e.target.value
                              ? Number(e.target.value.replace(/\s/g, ''))
                              : 0
                          );
                        }}
                        lg
                        label="Количество токенов"
                      />
                    </div>
                  </form>
                </>
              }
              footer={
                <FormFooter>
                  <div className="flex justify-end" style={{ width: '100%' }}>
                    <IconBtn
                      disabled={!initialTokenName || !paymentCount}
                      onClick={handleSubmit}
                      icon={UcpIcon}
                      title="Выбрать токен"
                    />
                  </div>
                </FormFooter>
              }
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default OrderSelectPaymentPage;
